import type * as React from 'react'
import { ReactElement } from 'react'

import { CaseItemStatus } from 'Portal/__generated__/globalTypes'

export type PreviewColumnProps = {
  id: string
  url?: string
  type: PreviewColumnTypeEnum
  headerElement?: ReactElement
  contentElement?: ReactElement
  isLoading?: boolean
  isOpen: boolean
  onClosePreviewColumn: () => void
  disableFooterAskQuestion?: boolean
  renderCustomFooterButton?: ReactElement
}

export type PreviewColumnHeaderProps = {
  name: string
  title?: string
  badge?: ReactElement | null
  image?: string | null
  productType?: string | null
  status?: CaseItemStatus
  onClosePreviewColumn: () => void
  renderPreviewColumnHeaderSub?: ReactElement
}

export type PreviewColumnContentProps = {
  content: PreviewColumnCellProps[]
  twoColumn?: boolean
}

export type PreviewColumnCellProps = {
  label: string
  value?: string | React.ReactElement | null
  copyable?: boolean
}

export type PreviewColumnFooterProps = {
  id: string
  isOpen: boolean
  url?: string
  type: PreviewColumnTypeEnum
  onClosePreviewColumn: () => void
  renderCustomFooterButton?: ReactElement
  disableAskQuestion?: boolean
}

export enum PreviewColumnTypeEnum {
  Rental = 'rental',
  Employee = 'employee',
  PhonePlan = 'phone plan',
  Request = 'request',
  Bundle = 'bundle',
}

export const PREVIEW_COLUMN_TYPE_TRANSLATION_IDS: Record<
  PreviewColumnTypeEnum,
  string
> = {
  [PreviewColumnTypeEnum.Rental]: 'PreviewColumn_type_rental',
  [PreviewColumnTypeEnum.Employee]: 'PreviewColumn_type_employee',
  [PreviewColumnTypeEnum.PhonePlan]: 'PreviewColumn_type_phone_plan',
  [PreviewColumnTypeEnum.Request]: 'PreviewColumn_type_request',
  [PreviewColumnTypeEnum.Bundle]: 'PreviewColumn_type_bundle',
}
